/**
 * Formats social counts in the compact style used by Shorts.
 *
 * Examples: 999 → "999", 1,584 → "1.6k", 12,000 → "12k".
 */
export function formatCompactCount(value: number): string {
  if (value < 1_000) return String(value);

  if (value < 1_000_000) {
    return `${(value / 1_000).toFixed(1).replace(/\.0$/, "")}k`;
  }

  return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
}
